<template>
  <Modal :id="'cmp_bookings_booking_add_artist'" @cancelled="onCancelClick">
    <template slot="header"> MANUAL MATCH - {{ currentChannel }} </template>
    <template slot="body">
      <div class="ut-fh ut-fc">
        <TopPart @search="onSearch" :modalData="modalData" />
        <BottomPart
          :modalData="modalData"
          @trackClick="onTrackClick"
          @productClick="onProductClick"
          @releaseClick="onReleaseClick"
          style="margin-top: 30px"
          :searchStringValue="searchString"
          @searchString="setsearchString"
          :currentChannel="currentChannel"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
      <button class="dt-button s7 v1" @click="onOKClicked">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import ModalContainer from "@dtplugins/modal/modal-container";

import TopPart from "./manual-match-top.vue";

import BottomPart from "./manual-match-bottom.vue";

import { DistributionStatementService } from "../../services/statement.service";
import { Subject } from "rxjs";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import { distributionStatementsActions } from "../../store/statement/actions";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
export default {
  components: {
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
    TopPart,
    BottomPart,

    //AdvanceSearch,
  },
  props: {},
  mounted: async function () {

    const resData = await DistributionStatementService.openStatementLine(
      this.statement_line_id
    );
    console.log("RES DATA", resData);

    this.searchString = resData.data?.stmt_line?.identifier || '';

    this.modalData = {
      ...resData.data,
      products:
        resData.data?.cost_group?.target === "physical"
          ? resData.data.physical_products
          : resData.data?.cost_group?.target === "physical" ||
            this.currentChannel === "thirdparty"
          ? resData.data.digital_products
          : this.currentChannel == "physical"
          ? resData.data.physical_products
          : resData.data.digital_products,
    };
    subscribeSubject(
      this,
      this.searchSubject$,
      (searchString) => {
        const { statement_id } = this.modalData.stmt_line;

        if (this.currentChannel === "performance") {
          DistributionStatementService.searchTrack(searchString).then(
            (searchResult) => {
              this.modalData = {
                ...this.modalData,
                tracks: [...searchResult.data.tracks],
                products: [],
              };
            }
          );
        } else if (
          this.currentChannel === "physical" ||
          this.cost_group_target === "physical" ||
          this.cost_group_target == "digital"
        ) {
          DistributionStatementService.searchMatchProduct(
            searchString,
            this.currentChannel === "physical"
              ? this.currentChannel
              : this.cost_group_target
          ).then((searchResult) => {
            this.modalData = {
              ...this.modalData,
              tracks: [],
              products: [...searchResult.data.products],
            };
          });
        } else if (this.cost_group_target === "release") {
          DistributionStatementService.searchReleases(searchString).then(
            (searchResult) => {
              this.modalData = {
                ...this.modalData,
                tracks: [],
                products: [],
                releases: [...searchResult.data.releases],
              };
            }
          );
        } else if (
          this.currentChannel === "digital" ||
          this.currentChannel === 'physical'
        ) {
          DistributionStatementService.searchProductTrack(
            statement_id,
            this.currentChannel,
            searchString,
            null
          ).then((searchResult) => {
            this.modalData = {
              ...this.modalData,
              tracks: [...searchResult.data.tracks],
              products: [...searchResult.data.products],
            };
          });
        } else {
          DistributionStatementService.searchProductTrack(
            statement_id,
            "null",
            searchString,
          ).then((searchResult) => {
            this.modalData = {
              ...this.modalData,
              tracks: [...searchResult.data.tracks],
              products: [...searchResult.data.products],
            };
          });
        }
      },
      this.currentChannel === "physical" ||
        this.currentChannel === "performance"
        ? 500
        : 1050
    );
  },
  data: function () {
    return {
      modalData: {},
      searchString: "",
      searchSubject$: new Subject(),
    };
  },
  mixins: [],

  computed: {
    statement_line_id: function () {
      return this.$route?.query?.statement_line_id || "";
    },
    statement_id: function () {
      return this.$route?.query?.statement_id || "";
    },
    currentChannel: function () {
      return this.$route?.query?.channel || "";
    },
    cost_group_target: function () {
      return this.modalData?.cost_group?.target || null;
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionStatementsActions),
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (key, value) {
      console.log("NAME", key, value);
      key = value;
    },

    onSearch: async function (payload) {
      const { statement_id } = this.modalData.stmt_line;
      this.searchString = payload.value;
      this.searchSubject$.next(this.searchString);
      // const searchResult =
      //   await DistributionStatementService.searchProductTrack(
      //     statement_id,
      //     "null",
      //     this.searchString
      //   );

      // console.log(payload, ":::::::::::::::::::::", searchResult);

      // this.modalData = {
      //   ...this.modalData,
      //   tracks: [...searchResult.data.tracks],
      //   products: [...searchResult.data.products],
      // };
    },
    setsearchString: async function (searchString) {
      this.searchSubject$.next(searchString);
      //console.log("this.searchString", searchString);
      this.searchString = searchString;
      // const { statement_id } = this.modalData.stmt_line;
      // const searchResult =
      //   await DistributionStatementService.searchProductTrack(
      //     statement_id,
      //     "null",
      //     this.searchString
      //   );
      // this.modalData = {
      //   ...this.modalData,
      //   tracks: [...searchResult.data.tracks],
      //   products: [...searchResult.data.products],
      // };
    },
    onReleaseClick: function (payload) {
      console.log("release", payload);
      this.modalData = {
        ...this.modalData,
        selectedData: {
          ...payload,
          artist: payload.release_artist,
          title: payload.release_title,
          isrc: payload.identifier,
          isRelease: true,
        },
      };
    },
    onTrackClick: function (payload) {
      console.log(payload);
      this.modalData = {
        ...this.modalData,
        selectedData: {
          ...payload,
          isTrack: true,
        },
      };
    },
    onProductClick: function (payload) {
      console.log(payload);
      this.modalData = {
        ...this.modalData,
        selectedData: {
          ...payload,
          artist: payload.release_artist,
          title: payload.release_title,
          isTrack: false,
        },
      };
    },
    onOKClicked: async function () {
      let external_id,
        external_table,
        channel,
        match_type = "";

      if (this.currentChannel === "digital") {
        external_id = this.modalData.selectedData.isTrack
          ? this.modalData.selectedData.track_id
          : this.modalData.selectedData.product_id;
        external_table = this.modalData.selectedData.isTrack
          ? "track"
          : "product";
        match_type = "digital";
        channel = "digital";
      } else if (this.currentChannel === "physical") {
        external_id = this.modalData.selectedData.isTrack
          ? this.modalData.selectedData.track_id
          : this.modalData.selectedData.product_id;
        external_table = this.modalData.selectedData.isTrack
          ? "track"
          : "product";
        match_type = "physical_product";
        channel = "physical";
      } else if (this.currentChannel === "thirdparty") {
        external_id = this.modalData.selectedData.isTrack
          ? this.modalData.selectedData.track_id
          : this.modalData.selectedData.product_id;
        external_table = this.modalData.selectedData.isTrack
          ? "track"
          : "product";
        match_type = "digital_physical_track";
        channel = "thirdparty";
      } else if (
        this.currentChannel === "costs" &&
        this.cost_group_target == "digital"
      ) {
        external_id = this.modalData.selectedData.product_id;
        external_table = "product";
        match_type = "digital_product";
        channel = "digital";
      } else if (
        this.currentChannel === "costs" &&
        this.cost_group_target === "physical"
      ) {
        external_id = this.modalData.selectedData.product_id;
        external_table = "product";
        match_type = "physical_product";
        channel = "physical";
      } else if (
        this.currentChannel === "costs" &&
        this.cost_group_target == "release"
      ) {
        external_id = this.modalData.selectedData.release_id;
        external_table = "release";
        match_type = "release";
        channel = "costs";
      } else if (this.currentChannel === "performance") {
        external_id = this.modalData.selectedData.isTrack
          ? this.modalData.selectedData.track_id
          : this.modalData.selectedData.product_id;
        external_table = this.modalData.selectedData.isTrack
          ? "track"
          : "product";
        match_type = "track";
        channel = "performance";
      }

      const res = await DistributionStatementService.setRelation({
        external_id: external_id,
        external_table: external_table,
        external_table2: "accounts",
        channel:
          this.currentChannel === "costs" &&
          (this.cost_group_target == "physical" ||
            this.cost_group_target == "digital")
            ? channel
            : null,
        external_id2: this.modalData.stmt.account_id,
        text02: this.modalData.stmt_line.identifier,
      });
      const res1 = await DistributionStatementService.updateStatementLines({
        external_id: external_id,
        external_table: external_table,
        channel: channel,
        statement_id: this.modalData.stmt.statement_id,
        identifier: this.modalData.stmt_line.identifier,
        match_type: match_type,
        account_id: this.modalData.stmt.account_id,
        digital_physical: this.modalData.stmt.digital_physical,
      });
      this[ActionTypes.DistributionStatementsDetailsRefresh.FETCH.SINGLE]({
        statement_id: this.modalData.stmt.statement_id,
      });
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
